/* st-jewelry — the guarantee / shipping / support strip: one slide at a time,
   swipe or tap a dot. */
(function () {
  function init(slider) {
    if (slider.dataset.stReady) return;
    slider.dataset.stReady = '1';
    var track = slider.querySelector('.st-info__track');
    var dots = slider.querySelectorAll('.st-info__dot');
    var index = 0, startX = 0, currentX = 0;

    function update() {
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    }
    slider.addEventListener('touchstart', function (e) {
      startX = currentX = e.touches[0].clientX;
    }, { passive: true });
    slider.addEventListener('touchmove', function (e) {
      currentX = e.touches[0].clientX;
    }, { passive: true });
    slider.addEventListener('touchend', function () {
      if (startX - currentX > 50 && index < dots.length - 1) index++;
      if (currentX - startX > 50 && index > 0) index--;
      update();
    });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { index = i; update(); });
    });
  }
  function boot() { document.querySelectorAll('[data-st-info]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* Elles-style stars-to-reviews navigation and Mae-style card controls. */
(function () {
  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function init(section) {
    if (section.dataset.reviewReady) return;
    section.dataset.reviewReady = '1';
    var track = section.querySelector('.st-reviews__track');
    if (!track) return;
    var prev = section.querySelector('[data-st-review-prev]');
    var next = section.querySelector('[data-st-review-next]');
    function update() {
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
    }
    function move(direction) {
      var card = track.querySelector('.st-reviews__card');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: reducedMotion() ? 'auto' : 'smooth'});
    }
    prev.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    track.addEventListener('scroll', update, {passive: true});
    track.addEventListener('keydown', function (event) {
      if (event.target !== track) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1);
      }
    });
    if (window.ResizeObserver) new ResizeObserver(update).observe(track);
    update();
    var dialog = section.querySelector('dialog');
    section.querySelectorAll('[data-st-review-photo]').forEach(function (button) {
      button.addEventListener('click', function () {
        var source = button.querySelector('img');
        var photo = dialog.querySelector('img');
        photo.src = source.src; photo.alt = source.alt;
        dialog.showModal();
      });
    });
    dialog.querySelector('[data-st-review-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) {
      var rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
    });
  }
  document.addEventListener('click', function (event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest('[data-st-review-link]');
    if (!link) return;
    var target = document.getElementById('st-reviews');
    if (!target) return;
    event.preventDefault();
    var header = document.querySelector('#SiteHeader');
    target.style.scrollMarginTop = ((header ? header.getBoundingClientRect().height : 0) + 24) + 'px';
    target.focus({preventScroll: true});
    target.scrollIntoView({behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start'});
    history.replaceState(null, '', '#st-reviews');
  });
  function boot() {
    document.querySelectorAll('.st-review-summary__avatars').forEach(function (holder) {
      if (holder.dataset.shuffled) return;
      holder.dataset.shuffled = '1';
      var indices = [1, 2, 3, 4, 5, 6, 7, 8];
      for (var i = indices.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var value = indices[i]; indices[i] = indices[j]; indices[j] = value;
      }
      holder.querySelectorAll('img').forEach(function (img, n) {
        img.src = 'https://rename-bucket-shopify.s3.eu-north-1.amazonaws.com/shopify-images/ms-avatar-female-' + indices[n] + '.webp';
      });
    });
    document.querySelectorAll('[data-st-reviews]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
